import { withInstall } from "../utils/index.mjs";
import _RadioGroup from "./RadioGroup.mjs";
const RadioGroup = withInstall(_RadioGroup);
var stdin_default = RadioGroup;
import { radioGroupProps } from "./RadioGroup.mjs";
export {
  RadioGroup,
  stdin_default as default,
  radioGroupProps
};
